<template>
  <div id="Technician" class="bg-color1" style="height:calc(100vh);">
    <div class="col-12" ref="index_head">
      <div class="col-12 h14 color-white">
        <div class="col-12 h14 bg-color-primary" style="position: relative;">
          <div class="col-12 lh40 pl10 pr10">
            <div class="col-3 f26" @click="app_select()"><i class="iconfont icon-modular"></i></div>
            <div class="col-6 t-c"><span class="f24 fw">POS</span>.com.ve</div>
            <div class="col-3 t-r f26" @click="login_out()"><i class="iconfont icon-exit"></i></div>
          </div>
          <div class="col-12 pl10 pr10 h10">
            <div class="col-3 h8"><img src="../assets/user.png" class="r5" style="height:80%"></div>
            <div class="col-9 pt5">
              <div class="col-12 f14"> Buen día </div>
              <div class="col-12 f18 uppercase"> {{$store.state.account.name}}</div>
              <div class="col-12 f12 mt5"> Última Sesión: {{$store.state.account.last_time}}</div>
            </div>
          </div>
          <div class="col-12 h3 t-c-v" style="position:absolute;bottom: -0.9rem;">
            <div class="fl"><input type="text" class="bg-color-white h4 b-s-2 r5 pl5 pr5 w28" placeholder="RIF" v-model="keyword" @keydown="keydown_event($event)"></div>
            <div class="b-s-2 r5 w4 h4 fl bg-color-white t-c-v f26 ml5" :class="[keyword != '' && keyword.length > 1?'color-primary fw':'color2']" @click="search_client()"><i class="iconfont icon-search"></i></div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 lh40 mt30 pl10 pr10 f18 fw uppercase">Funciones</div>
        <div class="col-12 pl10 pr10 mt10">
          <div class="col-4 pl5 pr5" @click="go_funds()">
            <div class="col-12 r5 h8 bg-color-primary b-s-1 t-c pt10">
              <div class="col-12 f30 color-white"><i class="iconfont icon-cunkuan"></i></div>
              <div class="col-12 f14 color-white">Fondos</div>
            </div>
          </div>
          <div class="col-4 pr5" @click="go_page('DistList')">
            <div class="col-12 r5 h8 bg-color-primary b-s-1 t-c pt10">
              <div class="col-12 f30 color-white"><i class="iconfont icon-jingxiaoshang"></i></div>
              <div class="col-12 f14 color-white">Distribuidor</div>
            </div>
          </div>
          <div class="col-4 pr5" @click="go_page('TecList')">
            <div class="col-12 r5 h8 bg-color-primary b-s-1 t-c pt10">
              <div class="col-12 f30 color-white"><i class="iconfont icon-type-of-work-managem"></i></div>
              <div class="col-12 f14 color-white">Técnico</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 lh40 mt10 pl10 pr10 f18 fw uppercase">Última activación</div>
    </div>
    <div class="col-12 pl10 pr10" style="overflow-y: auto;" :style="{ height: this.extension_list_h + 'px'}">
      <div class="col-12 bg-color-white r5 p5 mb8 ho1" v-for="(extension, extension_i) in extension_list" v-bind:key="extension_i" @click="go_ext(extension.extid)">
          <div class="col-2 f40 color-primary br1 t-c"><i class="iconfont icon-diannao"></i></div>
          <div class="col-9 pl10">
            <div class="col-12 f14">{{extension.license_type}}{{extension.license}}</div>
            <div class="col-12 fw f18">{{extension.extension_name}}</div>
            <div class="col-12 color-muted f12">{{extension.activation_time}}</div>
          </div>
          <div class="col-1 color-muted t-r lh50"><i class="iconfont icon-31fanhui2"></i></div>
      </div>
    </div> 
    <!--
    <div ref="app_foot" class="col-12 fixed-b t-c color2 f14 lh50 bg-color1 b-s-1">Versión: {{$store.state.set.app_ver}}</div>
    -->
    <div class="cover" @click="menu()" v-if="menu_on"></div>
    <div class="fixed-l h-100 w20" v-if="menu_on">
      <div class="col-12 bg-color-white h-100">
        <div class="col-12 h15 mb10 bg-color-primary color-white uppercase">
          <div class="col-12 t-c pt10">
            <img src="../assets/user.png" alt="" class="w10 r50">
          </div>
          <div class="col-12 t-c lh40">
            {{$store.state.account.name}}
          </div>
        </div>
        <div class="col-12 uppercase t-c-v f12 lh30 mt10" v-if="$store.state.account.account_grade >= 90">
          <div class="fl pl10 pr10 rtl5 rbl5" @click="login_type_ch('Technician')" :class="[$store.state.app_type == 'Technician'?'bg-color-primary color-white':'b1']">Técnico</div>
          <div class="fl pl10 pr10 rtr5 rbr5" @click="login_type_ch('Agent')" :class="[$store.state.app_type == 'Agent'?'bg-color-primary color-white':'b1']">Agencia</div>
        </div>
        <div class="col-12 pl8 pr8 f14 color-muted mt10">
          <div class="col-12 lh50" @click="go_profile()">
            <div class="col-3"><i class="iconfont icon-profile_light f22"></i></div>
            <div class="col-9">Perfil</div>
          </div>
          <div class="col-12 lh50" @click="go_safety()">
            <div class="col-3"><i class="iconfont icon-anquan f22"></i></div>
            <div class="col-9">Seguridad</div>
          </div>
          <div class="col-12 lh50" @click="go_about()">
            <div class="col-3"><i class="iconfont icon-info f22"></i></div>
            <div class="col-9">Acerca de la APP</div>
          </div>
        </div>
        <div class="col-12 fixed-b w20 pb10">

        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Technician',
  data () {
    return {
      login_type:1,
      keyword:'',
      extension_list: [],
      menu_on: false,
      extension_list_h:''
    }
  },
  created: function () {
    this.get_extensions();
  },
  mounted() {
    this.$store.commit('setBodyH', this);
    var top_h = this.$refs.index_head.offsetHeight;
    this.extension_list_h = window.innerHeight - top_h;
    //console.log(window.innerHeight)
    //console.log(this.$refs.index_head.offsetHeight+this.$refs.index_foot.offsetHeight+this.$refs.index_func.offsetHeight+this.$refs.index_ula.offsetHeight)

    //console.log(window.innerHeight - top_h)
   // console.log(this.$refs.index_head.offsetHeight)
   // console.log(this.$refs.index_foot.offsetHeight)
   // console.log(this.$refs.index_func.offsetHeight)
    //console.log(this.$refs.index_ula.offsetHeight)
    //this.handleResize();
  },
  methods: {
    login_type_ch:function(type_name){
      this.$store.commit('setApp',type_name);
      this.$router.push({name:'Start'});
    },
    search_client: function(){
      var keyword = this.keyword;
      if(keyword == '' || keyword.length < 2){
        this.$store.commit('setSound',true);
        return false;
      }else{
        this.$store.commit('setClientKeyword', this.keyword);
        this.$router.push({name:'A_ClientsList'});
      }
    },
    login_out:function(){
      localStorage.setItem("token",'');
      this.$router.push({name:'Login'});
    },
    go_clients:function(){
      this.$store.commit('setClientKeyword', '');
      this.$router.push({name:'A_ClientsList'});
    },
    go_funds: function(){
      this.$router.push({name:'Funds'});
    },
    go_profile: function(){
      this.$router.push({name:'Profile'});
    },
    go_safety: function(){
      this.$router.push({name:'Safety'});
    },
    go_about: function(){
      this.$router.push({name:'About'});
    },
    go_checker: function() {
      this.$router.push({name:'Checker'});
    },
    go_dist_list: function(){
      this.$router.push({name:'DistList'});
    },
    go_page: function(page_name){
      this.$router.push({name:page_name});
    },
    get_extensions:function(){
      this.post(this.api_url + 'Agent/extensions','',true).then((res)=>{
        if(res.status == 1){
          this.extension_list = res.data;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    menu:function() {
      if(this.menu_on){
        this.menu_on = false;
      }else{
        this.menu_on = true;
      }
    },
    app_select:function(){
      this.$router.push({name:'AppSelect'});
    },
    go_ext:function(extid){
      this.$router.push({name:'A_Extension',query:{extid: extid}});
    },
    handleResize() {
      //顶部和底部的高度和
      var tb_h = this.$refs.index_head.offsetHeight + this.$refs.index_foot.offsetHeight;
      var body_h = window.innerHeight - tb_h;
      this.$store.commit('setBodyH',body_h);
      console.log(body_h)
    },
    keydown_event:function(event){
      var keyCode
      if(typeof(event) == "number"){
          keyCode = event
      }else{
          keyCode = event.keyCode
      }
      switch(keyCode) {
        case 13:
          this.search_client();
        break;
      } 
    }
  },
  components: {}
}
</script>



// WEBPACK FOOTER //
// src/components/Agent.vue